// extracted by mini-css-extract-plugin
module.exports = {"main":"Menu_main__xRqIg"};